import { Location } from "history";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom-v5-compat";

import { isSignedIn as isUserSignedIn } from "seneca-common/features/user/state";
import { useLinkToAppropriateHomepage } from "seneca-common/utils/hooks/routing/useRedirectToAppropriateHomepage";
import { useTypedState } from "seneca-common/utils/routing/react-router-typesafe-routes/dom";

import CheckYourEmail from "features/sign-up/common-routes/components/passwordless/CheckYourEmail";
import SignUpFormBottomLink from "features/sign-up/components/SignUpFormBottomLink";
import { linkToSignIn } from "features/sign-up/links";
import { ROUTES } from "routing/routes";

export function getCallbackUrl({
  redirectAuthenticatedUserToLocation,
  signInLocation
}: {
  redirectAuthenticatedUserToLocation?: string;
  signInLocation: Location;
}) {
  return `${window.location.origin}${ROUTES.SIGN_IN_VIA_LINK.buildPath(
    {},
    {
      redirectAuthenticatedUserToLocation,
      pageReferrer: `${signInLocation.pathname}${signInLocation.search}`
    }
  )}`;
}

export default function CheckYourEmailRoute() {
  const { email, redirectAuthenticatedUserToLocation, signInLocation } =
    useTypedState(ROUTES.SIGN_IN_CHECK_YOUR_EMAIL);

  const isSignedIn = useSelector(isUserSignedIn);
  const linkToHomepage = useLinkToAppropriateHomepage();

  if (isSignedIn) {
    return (
      <Navigate
        to={redirectAuthenticatedUserToLocation ?? linkToHomepage}
        replace
      />
    );
  }

  if (!email || !signInLocation) {
    return <Navigate to={linkToSignIn()} replace />;
  }

  const callbackUrl = getCallbackUrl({
    redirectAuthenticatedUserToLocation,
    signInLocation
  });

  return (
    <CheckYourEmail email={email} callbackUrl={callbackUrl}>
      {{
        alternativeLoginLink: (
          <SignUpFormBottomLink
            bottomText="Having trouble accessing your email?"
            bottomLink={signInLocation}
            bottomLinkText="Log in another way"
          />
        )
      }}
    </CheckYourEmail>
  );
}
